import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-00d4c9ee"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  id: "tutorial",
  class: "mx-auto wrapper"
};

const _hoisted_2 = /*#__PURE__*/_createTextVNode("如何領取 Demi Trader NFT");

const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "sub-landing-title lh-base"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "text-white fs-2xl"
}, "開始創建屬於你的數位錢包")], -1));

const _hoisted_4 = {
  class: "center link-wrapper"
};

const _hoisted_5 = /*#__PURE__*/_createTextVNode("錢包創建教學");

const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text-white lh-lg text-start"
}, [/*#__PURE__*/_createElementVNode("iframe", {
  id: "ytplayer",
  type: "text/html",
  width: "1080",
  height: "608",
  src: "https://www.youtube.com/embed/QIuxnByl3I4",
  frameborder: "0"
})], -1));

export function render(_ctx, _cache) {
  const _component_landing_title = _resolveComponent("landing-title");

  const _component_button_link = _resolveComponent("button-link");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_landing_title, null, {
    default: _withCtx(() => [_hoisted_2]),
    _: 1
  }), _hoisted_3, _createElementVNode("div", _hoisted_4, [_createVNode(_component_button_link, null, {
    default: _withCtx(() => [_hoisted_5]),
    _: 1
  })]), _hoisted_6]);
}